import { useForm } from 'react-hook-form'
import { carVehicleCategoriesOptions, Option } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider } from '~/shared/ui/form'
import { MultiButtons } from '~/shared/ui/ScrollableList'

export type FormValues = { vehicleCategories: Option[] }

type ContentProps = {
  onSuccess: (values: FormValues) => void
}

export function Content({ onSuccess }: ContentProps) {
  const form = useForm<FormValues>()

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <MultiButtons
        field='vehicleCategories'
        options={carVehicleCategoriesOptions}
        title='Выбор тарифа авто'
      />

      <Button
        style={{ marginTop: '24px' }}
        variant='limeFlooded'
        size='large'
        fullWidth
        type='submit'
      >
        Применить
      </Button>
    </FormProvider>
  )
}
